"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventEmitter = undefined;

var _form = require("../actions/form");

var eventEmitter = exports.eventEmitter = function eventEmitter(store) {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case _form.SUBMIT_SUCCESS:
          window.dispatchEvent(new CustomEvent("otrSubmit"));
      }

      return next(action);
    };
  };
};